import React from 'react';
import styled from 'styled-components';

const StandardDeduction = ({data}) => {
    const curFormat = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const typeArr = [];
    data.types.map((type) => {
        return typeArr.push(type);
    });

    return (
        <StandardDeductionStyled className='StandardDeduction'>
            <h3><strong>Standard Deduction</strong></h3>
            <div className='table-responsive-sm'>
                <table className='table table-bordered'>
                    <thead>
                      <tr>
                        <th/>
                        <th/>
                      </tr>
                    </thead>
                    <tbody>
                        {
                            data.data.map((cellData, idx) => {
                                let spanVal = 0;
                                cellData.length == 1 ? spanVal = 2 : spanVal = 0;
                                return <tr key={idx} className={ idx }>{
                                    cellData.map((data, idx) => {
                                        typeArr[idx] === "currency" && curFormat.format(data) !== '$NaN' ? data = curFormat.format(data) : data;
                                        return <td key={idx} colSpan={spanVal}>{data}</td>
                                    })
                                }</tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
        </StandardDeductionStyled>
    );
}

export default StandardDeduction;

const StandardDeductionStyled = styled.div`
    margin-bottom: 15px;
    table {
        tbody {
            tr {
                border-bottom: 1px solid #ddd;
                :last-child{
                    border-bottom: none;
                }
            }
            td {
                border-right: 1px solid #ddd;
                :last-child{
                    border-right: none;
                }
            }
        }
    }
`;